import type { CSSProperties } from 'react';

import { wacToken } from '@/libraries/design/foundations';

import {
	columnStackStyle,
	ExampleUsage,
	OrgNeedsCard,
	panelStyle,
	panelTitleStyle,
} from './estimate-step';
import { ShareButton } from './share-button';
import { StepNav } from './step-nav';
import { Stepper } from './stepper';

export const EstimateCsrStep = () => (
	<>
		<Stepper />
		<h2 style={stepTitleStyle}>Estimate</h2>
		<div style={columnStackStyle}>
			<div style={splitThirdsRowStyle}>
				<OrgNeedsCard />
				<div style={panelStyle}>
					<h3 style={panelTitleStyle}>Monthly Cost estimate</h3>
				</div>
				<ExampleUsage />
			</div>
			<CustomValueCard />
		</div>
		<StepNav showBack />
		<ShareButton />
	</>
);

const CustomValueCard = () => (
	<div style={panelStyle}>
		<h3 style={panelTitleStyle}>Get Service Collection to use with your CS Resolutions</h3>
		<p style={bodyTextStyle}>
			Elevate support experiences, keep critical services running, and deliver value fast.
		</p>
		<a style={linkStyle} href="/collections/service/pricing">
			Explore Service Collection
		</a>
	</div>
);

const splitThirdsRowStyle: CSSProperties = {
	display: 'grid',
	gridTemplateColumns: 'repeat(3, 1fr)',
	gap: 16,
	alignItems: 'stretch',
};

// Local copies of the two styles previously exported from estimate-step.tsx.
// The main Estimate step no longer needs them (CTA is now a design-library
// button in a ContentBlock), so they live here alongside their sole remaining
// caller — the CSR-specific `CustomValueCard`.
const bodyTextStyle: CSSProperties = {
	margin: '0 0 12px',
	fontSize: 14,
	color: wacToken('color.neutral.light1100'),
};

const linkStyle: CSSProperties = {
	fontSize: 14,
	fontWeight: 600,
	color: wacToken('color.primary.blue'),
	textDecoration: 'none',
	cursor: 'pointer',
	alignSelf: 'flex-start',
};

// Local copy of the plain 22px section title. The main Estimate step now
// uses the design-system H3 + body-large header pattern; the CSR variant
// hasn't been redesigned yet so it keeps its original heading treatment.
const stepTitleStyle: CSSProperties = {
	margin: 0,
	fontSize: 22,
	fontWeight: 700,
	color: wacToken('color.neutral.light1100'),
};
